export default class Tutorial {
	constructor(finger, panel, scene, commands) {
		this._finger = finger;
		this._panel = panel;
		this._scene = scene;
		this._commands = commands;
		this._destroyed = false;
		this.stage = 0;
		this.tweens = new P3.utils.TWEEN.Group();
		this.signals = {
			update: new P3.utils.MiniSignal()
		};
	}

	update() {
		this.tweens.update();
	}

	play() {
		this._destroyed = false;
		this.signals.update.dispatch();
	}

	stop() {
		this.tweens.removeAll();
		this._destroyed = true;
	}

	destroy() {
		this.stop();
		this._destroyed = true;

		P3.utils.destroyAllSignals(this.signals);
	}

	prepareCommands() {

	}
}
